import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Navigate, Route } from "react-router-dom";
import {
  getRoleFromLocal,
  isLoginFromSoilApp,
} from "../globals/authentication";
import { isLoggedIn } from "../globals/utils";
import { publicRoutes } from "../routes/publicRoutes";
import { HOME_PAGE } from "../globals/const";
import Loader from "../components/Loader";
import { farmerRoutes } from "../routes/roleRoutes/farmerRoutes";
import BottomNav from "../components/Custom/BottomNavigation";
import BottomFarmernavItems from "../components/Links/NavItems";
import { fpoRoutes } from "../routes/roleRoutes/fpoRoutes";
import { fpoAggregatorRoutes } from "../routes/roleRoutes/fpoAggregatorRoutes";
import { lenderRoutes } from "../routes/roleRoutes/lenderRoutes";
import { auditorRoutes } from "../routes/roleRoutes/auditorRoutes";
import { popManagerRoutes } from "../routes/roleRoutes/popManagerRoutes";
import { getCommonAuthRoutes } from "../routes/commonAuthRoutes";
import { adminRoutes } from "../routes/roleRoutes/adminRoutes";
import { centralAdminRoutes } from "../routes/roleRoutes/centralAdminRoutes";
import { areaManagerRoutes } from "../routes/roleRoutes/areaManagerRoutes";
import { vleRoutes } from "../routes/roleRoutes/vleRoutes";
import { buyerRoutes } from "../routes/roleRoutes/buyerRoutes";
import { transporterRoutes } from "../routes/roleRoutes/transporterRoutes";
import { processorRoutes } from "../routes/roleRoutes/processorRoutes";
import { storageRoutes } from "../routes/roleRoutes/storageRoutes";
import { sponsorRoutes } from "../routes/roleRoutes/sponsorRoutes";
import { verifierRoutes } from "../routes/roleRoutes/verifierRoutes";
import { agroExpertRoutes } from "../routes/roleRoutes/agroExpertRoutes";
import { serviceProviderRoutes } from "../routes/roleRoutes/serviceProviderRoutes";
import { programManagerRoutes } from "../routes/roleRoutes/programManagerRoutes";
import { franchiseRoutes } from "../routes/roleRoutes/franchiseRoutes";
import { plantInchargeRoutes } from "../routes/roleRoutes/plantInchargeRoutes";
import { trackPageView } from "../utils/analytics";
// Define all role-based routes
const roleRouteMap = {
  FARMER: farmerRoutes,
  FPO: fpoRoutes,
  FPO_AGGREGATOR: fpoAggregatorRoutes,
  LENDER: lenderRoutes,
  AUDITOR: auditorRoutes,
  POP_MANAGER: popManagerRoutes,
  ADMIN: adminRoutes,
  CA: centralAdminRoutes,
  AREA_MANAGER: areaManagerRoutes,
  VLE: vleRoutes,
  BUYER: buyerRoutes,
  TRANSPORTER: transporterRoutes,
  PROCESSOR: processorRoutes,
  STORAGE: storageRoutes,
  SPONSOR: sponsorRoutes,
  VERIFIER: verifierRoutes,
  AGRO_EXPERT: agroExpertRoutes,
  SERVICE_PROVIDER: serviceProviderRoutes,
  PROGRAM_MANAGER: programManagerRoutes,
  FRANCHISE: franchiseRoutes,
  PLANT_INCHARGE: plantInchargeRoutes,
};

// Define roles that should show bottom navigation
const ROLES_WITH_BOTTOM_NAV = [
  "FARMER",
  "FPO",
  "SPONSOR",
  "BUYER",
  "AGRO_EXPERT",
  "POP_MANAGER",
  "AREA_MANAGER",
  "VLE",
];

export default function AppRoutes() {
  const [role, setRole] = useState("");
  const [navItems, setNavItems] = useState([]);
  const loggedIn = isLoggedIn();
  const isSoilAppLogin = isLoginFromSoilApp();

  // Pre-initialize nav items
  const itemsFarmer = BottomFarmernavItems("FARMER");
  const itemsFpo = BottomFarmernavItems("FPO");
  const itemsSponsor = BottomFarmernavItems("SPONSOR");
  const itemsBuyer = BottomFarmernavItems("BUYER");
  const itemsAgroExpert = BottomFarmernavItems("AGRO_EXPERT");
  const itemsPOPManager = BottomFarmernavItems("POP_MANAGER");
  const itemsAreaManager = BottomFarmernavItems("AREA_MANAGER");
  const itemsVLE = BottomFarmernavItems("VLE");

  useEffect(() => {
    const userRole = getRoleFromLocal();
    trackPageView();
    setRole(userRole);

    // Set nav items based on role
    switch (userRole) {
      case "FARMER":
        setNavItems(itemsFarmer);
        break;
      case "FPO":
        setNavItems(itemsFpo);
        break;
      case "SPONSOR":
        setNavItems(itemsSponsor);
        break;
      case "BUYER":
        setNavItems(itemsBuyer);
        break;
      case "AGRO_EXPERT":
        setNavItems(itemsAgroExpert);
        break;
      case "POP_MANAGER":
        setNavItems(itemsPOPManager);
        break;
      case "AREA_MANAGER":
        setNavItems(itemsAreaManager);
        break;
      case "VLE":
        setNavItems(itemsVLE);
        break;
      default:
        setNavItems([]);
    }
  }, []);

  // Check if role should show bottom navigation
  const shouldShowBottomNav = (userRole) => {
    return ROLES_WITH_BOTTOM_NAV.includes(userRole) && !isSoilAppLogin;
  };

  return (
    <BrowserRouter>
      <Loader>
        {loggedIn && shouldShowBottomNav(role) && (
          <BottomNav navItems={navItems} />
        )}

        <Routes>
          {/* Public routes accessible to all users */}
          {publicRoutes}

          {/* Role based routes */}
          {loggedIn && roleRouteMap[role]}

          {/* Common authenticated routes */}
          {loggedIn && getCommonAuthRoutes(role)}

          <Route
            exact
            path={"/"}
            element={
              isLoggedIn() ? (
                <Navigate to={HOME_PAGE} />
              ) : (
                <Navigate to={`${HOME_PAGE}/landing`} />
              )
            }
          />
        </Routes>
      </Loader>
    </BrowserRouter>
  );
}
